import client from "../client";

interface Request {
  prefix?: string;
}

export interface GetSettingReturnToLossResponse {
  VenderID: number;
  Amount: number;
  CreatedAt: Date;
  UpdateAt: Date;
  IsCredit: boolean;
  DisplayCreatedAt: string;
  DisplayUpdatedAt: string;
}

export default function API(
  request: Request
): Promise<GetSettingReturnToLossResponse> {
  return client
    .get(`commission/get_setting_return_to_loss`, {
      params: request,
    })
    .then((response) => response.data)
    .then((json: GetSettingReturnToLossResponse) => {
      return json;
    });
}
